import { AdminPlace } from '../model/adminPlace';
export class AdminPlaceBuilder {
    static buildAdminPlace(data) {
        const adminPlace = new AdminPlace();
        adminPlace.place_id = data.place_id;
        adminPlace.city_id = data.city_id;
        adminPlace.name_es = data.name_es;
        adminPlace.name_ca = data.name_ca;
        adminPlace.name_en = data.name_en;
        adminPlace.name_fr = data.name_fr;
        adminPlace.type = data.type;
        adminPlace.lat = data.lat;
        adminPlace.lng = data.lng;
        return adminPlace;
    }
}
//# sourceMappingURL=adminPlace-builder.js.map